/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_LeadInputs */

const en_mk_sol_agensi_lead = /** @type {(inputs: Mk_Sol_Agensi_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eight clients running at once, three of them wanting weekly content. The expensive part is not the ideas — it is the hours lost redrafting and chasing approvals.`)
};

const id_mk_sol_agensi_lead = /** @type {(inputs: Mk_Sol_Agensi_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delapan klien berjalan bersamaan, tiga di antaranya minta konten mingguan. Yang mahal bukan ide, melainkan waktu yang habis untuk menyusun ulang draf dan mengejar persetujuan.`)
};

/**
* | output |
* | --- |
* | "Eight clients running at once, three of them wanting weekly content. The expensive part is not the ideas — it is the hours lost redrafting and chasing approv..." |
*
* @param {Mk_Sol_Agensi_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_lead = /** @type {((inputs?: Mk_Sol_Agensi_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_lead(inputs)
	return en_mk_sol_agensi_lead(inputs)
});